import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    if (this.hasPanelTarget) this.showBay(parseInt(this.panelTargets[0].dataset.bay))
  }

  select(event) {
    this.showBay(parseInt(event.currentTarget.dataset.bay))
  }

  showBay(bayNum) {
    this.panelTargets.forEach(p => {
      p.style.display = parseInt(p.dataset.bay) === bayNum ? "" : "none"
    })
    this.tabTargets.forEach(t => {
      const active = parseInt(t.dataset.bay) === bayNum
      t.classList.toggle("bg-sapphire", active)
      t.classList.toggle("text-white", active)
      t.classList.toggle("border-sapphire", active)
      t.classList.toggle("bg-white", !active)
      t.classList.toggle("text-slate-600", !active)
      t.classList.toggle("border-slate-200", !active)
    })
  }
}
